export default "__VITE_ASSET__8934a047__"